import { Link } from '@remix-run/react'
import headshot from './dina353x326.jpg'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			{/* <Helmet
      title="Dina Gmeinweiser"
      meta={[
        {
          name: "description",
          content: "Hi, I'm Dina. I'm here to help with your insurance.",
        },
        {
          name: "keywords",
          content: "Dina Gmeinweiser",
        },
      ]}
    /> */}
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>{' '}
			&rarr;{' '}
			<Link
				to="/about-us/"
				className="text-blue-600 underline"
				prefetch="intent"
			>
				About Us
			</Link>
			<br />
			<br />
			<h1 className="text-4xl font-black">Dina Gmeinweiser</h1>
			<span className="image">
				<img
					src={headshot}
					alt="Dina Gmeinweiser"
					className="max-w-md rounded-lg"
				/>
			</span>
			<br />
			<br />
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Dina has been with our agency since 2014, coming to us with 10 years
				experience in Property and Casualty Insurance. Dina is licensed in all
				personal lines of insurance and enjoys helping our clients with their
				insurance needs. Dina also helps keep our agency connected to our
				clients and community through social media- feel free to contact her
				with any awesome local events we can share! When not at work, Dina
				enjoys time with her husband, two kids, and two chihuahuas.
			</p>
		</main>
	)
}
